import React from "react";
import { api } from "@/utils/api";
import localforage from "localforage";
import { openLink } from "@/utils";

class PdfFileItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfFile: "",
    };
  }

  componentDidMount() {
    this.getRealPdf();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pdfFile !== this.props.pdfFile) {
      this.getRealPdf();
    }
  }

  getRealPdf = () => {
    const { pdfFile } = this.props;
    const path = pdfFile.split("key=");
    if (path.length > 1) {
      const key = path[1];
      localforage
        .getItem(key)
        .then((value) => {
          if (value) {
            this.setState({
              pdfFile: URL.createObjectURL(value),
            });
          } else {
            api.image
              .getByKey({ key })
              .then((response) => {
                localforage.setItem(key, response).catch((error) => {
                  console.error(error);
                });
                this.setState({
                  pdfFile: URL.createObjectURL(response),
                });
              })
              .catch((error) => {
                console.error("error: " + error.message);
              });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      this.setState({ pdfFile: pdfFile });
    }
  };

  toPdf = (pdfLink) => {
    const { itemId, libraryType, pdfTitle, target, isDownload } = this.props;
    openLink(pdfLink, itemId, libraryType, pdfTitle, target, isDownload);
  };

  render() {
    const { pdfTitle, className, title, children } = this.props;
    const { pdfFile } = this.state;
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a className={className} onClick={() => this.toPdf(pdfFile)} tabIndex="0">
        {children || title || pdfTitle}
      </a>
    );
  }
}

export default PdfFileItem;
